<template>
  <div class="membership-banner-container text-center">
    <slot name="title"></slot>
    <slot name="description"></slot>
  </div>
</template>
<script>
export default {
  name: 'Story',
};
</script>

<style lang="scss">
.membership-banner-container {
  min-width: 200px;
  height: 410px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  h1 {
    font-size: 48px !important;
    font-family: 'Campton Bold', sans-serif;
    font-weight: normal;
    color: #fff;
    line-height: 1.1;
    font-weight: 800;
  }
  p {
    font-size: 20px !important;
    color: #fff;
  }
  .ql-bubble .ql-editor {
    text-align: center;
    &:before {
      color: #fff;
    }
  }
}
.membership-template-builder .tablet-template {
  .membership-banner-container {
    height: 320px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-left: 0px;
    h1,
    p,
    h2,
    h3 {
      -webkit-line-clamp: 3 !important;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
    .page-heading .quill-editor p,
    .page-heading p,
    .page-heading h1 {
      font-size: 40px !important;
    }
  }
}
.membership-template-builder .mobile-template {
  .membership-banner-container {
    height: 181px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-left: 0px;
    h1,
    p,
    h2,
    h3 {
      -webkit-line-clamp: 2 !important;
      display: -webkit-box;
      -webkit-box-orient: vertical;
    }
    .page-heading .quill-editor p,
    .page-heading p,
    .page-heading h1 {
      font-size: 32px !important;
    }
  }
}

.membership-template-builder {
  .membership-banner-container {
    h1,
    p,
    h2,
    h3 {
      //  display: -webkit-box;
      //   -webkit-line-clamp: 4;
      //   -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .page-heading .quill-editor p,
    .page-heading p {
      font-size: 48px !important;
      font-family: 'Campton Bold', sans-serif;
      line-height: 1.1;
      margin-bottom: 5px;
      font-weight: 800;
    }
  }
}
@media only screen and (max-width: 992px) {
  .membership-banner-container {
    height: 320px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-left: 0px;
    h1,
    p,
    h2,
    h3 {
      -webkit-line-clamp: 3 !important;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .page-heading .quill-editor p,
    .page-heading p,
    .page-heading h1 {
      font-size: 40px !important;
    }
  }
}
@media only screen and (max-width: 767px) {
  .membership-banner-container {
    height: 181px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-left: 0px;
    h1,
    p,
    h2,
    h3 {
      -webkit-line-clamp: 2 !important;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .page-heading .quill-editor p,
    .page-heading p,
    .page-heading h1 {
      font-size: 32px !important;
    }
  }
}
</style>
